// Angular
import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
// Translate
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
// Fuse
import {FuseConfigService} from '@fuse/services/config.service';
import {FuseSidebarService} from '@fuse/components/sidebar/sidebar.service';
// Component Local
import {navigation} from 'app/navigation/navigation';
import { Router } from '@angular/router';
// @ts-ignore
import defaultAvatar from 'assets/images/logos/beco-short.png';
import { DashboardService } from '../../../main/dashboard/dashboard.service';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    // Data bindings
    name = '';
    logo = '';
    lang = '';
    role = '';
    complex = {
        id: '',
        name: '',
    };
  unreadNotifications = 0;
  supplierId: string | null;
  data = [];
    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private dashboardService: DashboardService,
        private router: Router,
    ) {
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            },
            {
                id: 'es',
                title: 'Español',
                flag: 'es'
            }
        ];

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        const token = localStorage.getItem('token');
        this.name = localStorage.getItem('name');
        this.logo = localStorage.getItem('logo');
        this.role = localStorage.getItem('role');
        const lang = localStorage.getItem('lang');
        this.supplierId = localStorage.getItem('supplier_id');
        if (lang !== undefined && lang !== '' && lang !== null) {
            this._translateService.use(lang);
        } else {
            this._translateService.use(this._translateService.currentLang);
        }

        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {id: this._translateService.currentLang});
        if (this.name !== '' && this.name !== null && this.name !== undefined) {
        //  this.notifications();
        }
    }

    logout(): void {
        localStorage.removeItem('token');
        localStorage.removeItem('complex_session');
        this.router.navigate(['/oauth/login/']);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

  avatarError(event: any): void {
    this.logo = defaultAvatar;
  }

  notifications(): void {
    this.dashboardService.getNotifications({
      supplier_id: this.supplierId,
      lang: this._translateService.currentLang,
    }).subscribe(
      result => {
        if (result.success === true) {
          this.unreadNotifications = result.data.unreadNotifications;
          this.data = result.data.notifications;
        }
      }
    );
  }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void {
        // Do your search here...
        console.log(value);
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;
        // Use the selected language for translations
        this._translateService.use(lang.id);
        localStorage.setItem('lang', lang.id);
    }
}
